import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "input-group-prepend"
}
const _hoisted_3 = { class: "input-group-text" }
const _hoisted_4 = ["id", "type", "disabled", "required", "placeholder", "aria-label", "max"]
const _hoisted_5 = { class: "invalid-feedback" }

import { computed } from "vue";


const __default__ = {
  name: "BaseInputPill",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  name: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    default: null,
  },
  value: {
    type: [String, Number],
    required: true,
  },
  placeholder: {
    type: String,
    default: null,
  },
  invalid: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: "text",
  },
  label: {
    type: String,
    required: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  max: {
    type: Number,
    default: null,
  },
  inline: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:value", "keyup", "onEnter"],
  setup(__props, { emit }) {

const props = __props;



const _value = computed({
  get() {
    return props.value;
  },
  set(val) {
    emit("update:value", val);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'd-flex align-items-center gap-2': __props.inline })
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: __props.name,
          class: "form-label"
        }, _toDisplayString(__props.label), 9, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({ 'input-group': __props.icon })
    }, [
      (__props.icon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _createElementVNode("i", {
                class: _normalizeClass(__props.icon)
              }, null, 2)
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        id: __props.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(_value) ? (_value).value = $event : null)),
        type: __props.type,
        disabled: __props.disabled,
        required: __props.required,
        class: _normalizeClass(["form-control rounded-pill text-secondary my-4 bg-light shadow", { 'is-invalid': __props.invalid }]),
        placeholder: __props.placeholder,
        "aria-label": __props.placeholder,
        max: __props.max !== null ? __props.max : undefined,
        onKeyup: _cache[1] || (_cache[1] = ($event: any) => (emit('keyup'))),
        onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (emit('onEnter')), ["enter"]))
      }, null, 42, _hoisted_4), [
        [_vModelDynamic, _unref(_value)]
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.invalid), 1)
    ], 2)
  ], 2))
}
}

})